// @flow

import * as React from 'react';

import clsx from 'clsx';

import styles from './CellCol.scss';

type Props = {
  children: React.Node,
  className?: string,
  ...
};

export default function CellCol({
  children,
  className,
  ...extraProps
}: Props): React.MixedElement {
  return (
    // $FlowFixMe[cannot-spread-inexact]
    <span className={clsx(styles.root, className)} {...extraProps}>
      {children}
    </span>
  );
}
